<template>
  <div>
    <div class="message-product" :style="'width: '+ this.width + 'px; height: '+ this.height + 'px;'" alt="点击查看商品" @click="handleClick">
      <div class="message-product-image">
        <img :src="fileBaseUrl+product.coverImg" width="100%" height="100%">
      </div>
      <div class="message-product-content">
        <div class="message-product-title" :style="'color: '+product.titleColor+';'">
          {{product.name}}
        </div>
        <div class="message-product-price">
          (佣金换购){{product.price}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MessageProduct",
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    productStr: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,
      product: null
    }
  },
  created() {
    console.log(this.productStr)
    this.product = JSON.parse(this.productStr)
  },
  methods: {
    handleClick(){
      this.$emit("click", this.product)
    },
  }
}
</script>

<style scoped lang="scss">
@import "MessageProduct";
</style>